import { useState, useEffect } from 'react';

/**
 * Hook para cargar el logo del cliente desde CloudFront
 * Si no existe, retorna null para usar el logo por defecto
 */
export const useClientLogo = () => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const cloudFrontUrl = process.env.REACT_APP_CLOUDFRONT_S3_URL;
    
    if (!cloudFrontUrl) {
      setIsLoading(false);
      return;
    }

    // Construir URL del logo
    const faviconUrl = `https://${cloudFrontUrl}/favicon.svg`;
    
    // Intentar cargar la imagen para verificar que existe
    const img = new Image();
    
    img.onload = () => {
      setLogoUrl(faviconUrl);
      setIsLoading(false);
      console.log('✅ Logo del cliente cargado desde CloudFront');
    };
    
    img.onerror = () => {
      setLogoUrl(null);
      setIsLoading(false);
      console.log('ℹ️ Logo del cliente no encontrado, usando logo por defecto');
    };
    
    img.src = faviconUrl;
  }, []);

  return { logoUrl, isLoading };
};
